import React from "react";
import "./Why_Work_With_Us.css";

function Why_Work_With_Us() {
  return (
    <>
      <section className="Why_Work_With_Us ">
        <div className="container">
        <h1 className="heading">Why</h1>
          <h1 className="title heading">Work With Us?</h1>

          <div className="content-holder">
            <div className="text-holder">
              <div className="row me-0 ms-0">
                <div className="col-lg-7 col-md-12 list-holder  ">
                  <div className="sign-img-holder top-left">
                    <img
                      className="sign-img"
                      src={
                        process.env.PUBLIC_URL +
                        "/Assets/Images/Career/Why_Work_With_Us/top-left2.png"
                      }
                    />
                  </div>

                  <div className="sign-img-holder bottom-right">
                    <img
                      className="sign-img"
                      src={
                        process.env.PUBLIC_URL +
                        "/Assets/Images/Career/Why_Work_With_Us/bottom-right2.png"
                      }
                    />
                  </div>
                  <ol>
                    <li> Innovative Environment.</li>
                    <li>
                      We foster creativity and out-of-the-box thinking,
                      encouraging our team to Explore new ideas and push
                      boundaries.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Why_Work_With_Us;
